/**
 * KBT Annual Impact stats — from the client's "Annual Impact" infographic
 * (Aug 2026). Real, published figures, not placeholders — do not round or
 * embellish them further.
 *
 * Each stat is structured data (numeric value + optional prefix/suffix),
 * not a pre-formatted string, so the count-up animation in
 * ImpactStat.js has a real number to animate toward and formatCount()
 * below is the single place that decides how it's displayed at rest.
 */

// 12 stats, deliberately — a clean 6x2 grid. "3 Torah publications launched
// this year" was dropped at the client's request to make the count even.
export const IMPACT_STATS = [
  { value: 7, label: 'Daily in-person Torah classes' },
  { value: 4, label: 'Rabbanim teaching daily' },
  { value: 50, suffix: '+', label: 'Weekly shiurim & chavrutot' },
  { value: 50, suffix: '+', label: 'Participants in Amud Yomi program' },
  { value: 80, suffix: '+', label: 'Students in Semicha program' },
  { value: 100, suffix: '+', label: 'Community members attending Shabbat' },
  { value: 19000, label: 'Hours of live Torah learning / year' },
  { value: 40000, label: 'Hours of digital Torah learning / year' },
  { value: 56000, suffix: '+', label: 'Views on TorahAnytime platform' },
  { value: 80000, label: 'Total Torah learning hours annually' },
  { value: 25000, suffix: '+', label: 'Dapim of Gemara learned this past year' },
  { value: 1000, suffix: '+', label: 'Questions answered through the Halacha Hotline' },
];

// Comma-grouped, no decimals — matches how every number is written on the
// source infographic (e.g. "19,000", "56,000+"), including for the small
// single-digit values where toLocaleString is a no-op.
export const formatCount = (value) => Math.round(Number(value) || 0).toLocaleString('en-US');
